import React from 'react';
import Type from 'prop-types';

const TaskSection = (props) => {
  const { children } = props;

  return (
    <li>
      <div style={{ marginBottom: '16px' }}>{children}</div>
    </li>
  );
};

TaskSection.propTypes = {
  children: Type.node.isRequired,
};

export default TaskSection;
